import { injectable } from 'inversify';

import type { GetBrandConcessionContentResponse } from './ownable.dtos';
import { GetBrandConcessionContent } from './ownable.dtos';
import ServiceStackGateway from './service-stack';

@injectable()
export class BrandConcessionsAPI {
  get = async (id: number) => {
    const request = new GetBrandConcessionContent();
    request.brandConcessionId = id;

    const response =
      await ServiceStackGateway.get<GetBrandConcessionContentResponse>(request);

    if (!response.success) {
      throw new Error(
        response.errors?.[0].userMessage ??
          `Unknown Error fetching Brand Concession Content with id ${id}`
      );
    }

    return response.brandConcession;
  };
}
